import { render, staticRenderFns } from "./sidemenu_twitter.vue?vue&type=template&id=1f630a92&"
import script from "./sidemenu_twitter.vue?vue&type=script&lang=js&"
export * from "./sidemenu_twitter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports